import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './ui/__generated__/IssueLinksPopUpContentQuery$parameters';

type EntryPointParams = {
	issueKey: string;
	cloudId: string;
};

export const issueLinksPopUpContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-issue-links-content" */ './ui/IssueLinksPopUpContent.tsx'),
	),
	getPreloadProps: ({ issueKey, cloudId }: EntryPointParams) => ({
		queries: {
			links: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					issueKey,
					cloudId,
					isNinStrikethroughResolutionUpdateEnabled: fg('nin-strikethrough-resolution-update'),
				},
			},
		},
	}),
});
